/**
 * Shared column geometry for the trades table.
 *
 * The header lives in TradingTable.js and the body rows in TradesRow.js, so the
 * two have to agree on the grid or the columns drift apart. They used to share
 * only `grid-cols-11` — eleven equal fractions — plus a `min-w-[900px]` floor.
 *
 * Eleven equal columns is the wrong shape for this data: "Index" needs ~34px
 * and "LOSANGELES" needs ~92px, so sizing every column for the widest one set
 * the floor at 900px. The trading page gives the table 869px at a 1440px
 * viewport, so the row overflowed by ~31px and the Edit/Close buttons fell off
 * the right edge behind a scrollbar.
 *
 * Each column now declares its own minimum and its share of any slack. The
 * minimums total 730px, so with the row's 40px of padding the table fits in
 * 770px and the floor drops to 780px — comfortably inside the 869px available,
 * with the slack distributed to the columns that benefit from it.
 *
 * The actions column is fixed rather than fractional: it holds 74px buttons and
 * has no text to reflow, so letting it stretch only steals space from columns
 * that need it.
 */
export const TRADES_GRID_COLUMNS = [
  "minmax(34px, 0.5fr)",   // Index
  "minmax(86px, 1fr)",     // Date
  "minmax(92px, 1.05fr)",  // Pair
  "minmax(62px, 0.8fr)",   // Type
  "minmax(74px, 1fr)",     // Entry Price
  "minmax(46px, 0.7fr)",   // Leverage
  "minmax(54px, 0.85fr)",  // Amount
  "minmax(54px, 0.85fr)",  // Size
  "minmax(58px, 0.85fr)",  // TP/SL
  "minmax(84px, 1.05fr)",  // PnL
  "86px",                  // Actions — fixed, holds the 74px buttons
].join(" ");

/** Sum of the minimums (730px) plus the row's horizontal padding (40px). */
export const TRADES_MIN_WIDTH = 780;

/**
 * Header and rows must carry identical horizontal padding or every column sits
 * a few pixels off between the two. The header used to inline 8px against the
 * row's 12/20px, which is why the labels never lined up with their values.
 */
export const TRADES_ROW_PADDING_X = "px-3 sm:px-5";
